import useFirstRender from 'hooks/useFirstRender'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'

import { getInvoice } from '../../actions/invoices'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import { ReactComponent as CloseIcon } from './close.svg'
import styles from './Invoice.module.scss'
import SingleInvoice from './SingleInvoice'

const Invoices = () => {
  const { isLoading, error, invoiceList } = useSelector(s => s.invoices)

  const dispatch = useDispatch()

  const { ids, shallPrint } = useParams()

  const invoiceIds = ids.split('-')

  useFirstRender(() => {
    dispatch(getInvoice(invoiceIds))
  })

  useEffect(() => {
    if (!isLoading && !error && shallPrint) {
      window.print()
    }
  }, [error, isLoading, shallPrint])

  useEffect(() => {
    document.body.classList.add('printMode')

    return () => document.body.classList.remove('printMode')
  }, [])

  if (isLoading || !invoiceList) {
    return <LoadingIndicator longWaitingTreshold={120} />
  }

  if (invoiceList && !invoiceIds.every(i => Object.keys(invoiceList).includes(i))) {
    return <LoadingIndicator longWaitingTreshold={120} />
  }

  if (error) {
    return <span>Invoice not found!</span>
  }

  return (
    <div className={styles.invoiceWrapper}>
      <div className={styles.wrapperHeader}>
        <Link to="/billing" className={styles.closeButton}>
          <button>
            <CloseIcon />
          </button>
        </Link>
      </div>
      {error && <span>Invoice not found!</span>}
      {isLoading && <LoadingIndicator longWaitingTreshold={120} />}
      {!error && !isLoading && (
        <div id="printArea" className={styles.printArea}>
          {invoiceIds.map(invoiceId => (
            <SingleInvoice
              {...invoiceList[invoiceId]}
              invoiceId={invoiceId}
              key={invoiceId}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default Invoices
